import { useNWC } from './useNWC';

/**
 * Unified Wallet helper determining payment capabilities in order: NWC -> WebLN -> Manual
 */
export function useWallet() {
  const { connections, activeConnection, getActiveConnection } = useNWC();

  const hasNWC = connections.length > 0;
  const activeNWC = getActiveConnection();

  // Simple WebLN detection (e.g. Alby window injection)
  const [webln, setWebln] = useState<any>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && (window as any).webln) {
      setWebln((window as any).webln);
    }
  }, []);

  const preferredMethod = activeNWC 
    ? 'nwc' 
    : webln 
    ? 'webln' 
    : 'manual';

  return {
    hasNWC,
    activeNWC,
    connections,
    webln,
    preferredMethod
  };
}

// React import fix helper
import { useEffect, useState } from 'react';
